import styled, { css } from "styled-components";
import { WrapperContainer } from "../../../../components";
import {
  BottomContainer,
  LeftContainer,
  MainContainer
} from "../../../../templates/SplittedModalContentTemplate/styled";
import { RadialChartContainer } from "../../../../components/Charts/styled";

const BottomContainerToggledStyles = css`
  ${MainContainer} {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
  }

  ${BottomContainer} {
    height: 100%;
    border-top: 0;
  }
`;

export const NotificationCampaignReportWrapper = styled(WrapperContainer)`
  width: 100%;
  height: 100%;

  ${(props) => props.isBottomToggled && BottomContainerToggledStyles}

  ${LeftContainer} {
    width: 45%;

    max-width: 300px;
    min-width: 250px;
  }

  ${MainContainer} {
    transition: 0.3s all;
  }

  ${BottomContainer} {
    transition: 0.3s all;
  }
`;

export const HorizontalChartWrapper = styled.div`
  ${RadialChartContainer} {
    flex-direction: row !important;
    justify-content: center;
    gap: 48px;
  }
`;

export const MarketsReportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
